import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const resolveMediaUrl = (url) =>
  url && url.startsWith("/api/") ? `${API.replace("/api", "")}${url}` : url;

export async function uploadMedia(file, kind) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("kind", kind);
  const { data } = await api.post("/admin/media/upload", formData);
  return data;
}
